import React from 'react';
import PropTypes from 'prop-types';


const CreditCardView = ({ brand, exp_month, exp_year, last4 }) => (
  <div className="credit-card-form_content">
    <div>
      <div className={'credit-card-form_logo pull-left -' + brand.toLowerCase()}></div>
      <div className="credit-card-form_info">
        <div className="credit-card-form_number">
          ****&nbsp;&nbsp;&nbsp;****&nbsp;&nbsp;&nbsp;****&nbsp;&nbsp;&nbsp;{last4}
        </div>
        <div className="credit-card-form_date">{exp_month}/{exp_year.slice(-2)}</div>
      </div>
    </div>
  </div>
);

CreditCardView.propTypes = {
  brand: PropTypes.string.isRequired,
  exp_month: PropTypes.string.isRequired,
  exp_year: PropTypes.string.isRequired,
  last4: PropTypes.string.isRequired,
};

CreditCardView.defaultProps = {
  brand: 'empty',
  exp_month: '99',
  exp_year: '99',
  last4: 'XXXX',
};

export default CreditCardView;


// WEBPACK FOOTER //
// ./app/javascript/components/card_details/components/CreditCard/View.js